import React from "react";

interface PopupProps {
    onClose: (cross: boolean) => void,
    children: React.ReactNode
}

export const Popup: React.FC<PopupProps> = ({ onClose, children }) => {
    return (
        <div
            className="z-[100000] fixed top-0 inset-0 flex justify-center bg-black bg-opacity-50 md:items-center md:justify-center"
            onClick={() => onClose(false)}
        >
            <div className="relative bg-white shadow-md w-full md:rounded-2xl min-h-[100svh] md:min-h-0 md:w-auto md:max-h-[calc(100vh-64px)] overflow-auto scrollbar-none" onClick={(e) => e.stopPropagation()}>
                { children }
                <button
                    className="absolute top-0 right-0 m-2 text-gray p-2 rounded"
                    onClick={() => onClose(true)}
                >
                    X
                </button>
            </div>
        </div>
    );
}